import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DynamicContentModalComponent } from './dynamic-content-modal.component';
import { DynamicContentOutletErrorComponent } from './dynamic-content-outlet-error.component';
import { DynamicContentOutletComponent } from './dynamic-content-outlet.component';
import { DynamicContentOutletService } from './dynamic-content-outlet.service';

@NgModule({
    imports: [CommonModule],
    declarations: [DynamicContentOutletComponent, DynamicContentOutletErrorComponent, DynamicContentModalComponent],
    exports: [DynamicContentOutletComponent],
    providers: [DynamicContentOutletService]
})
export class DynamicContentOutletModule {}
